"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-arrow-right-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M12 21v5l16-7.5L12 12v5H.625v4H12z", fill: "#4C4C4C" }),
            _react2.default.createElement("path", { d: "M19 37c9.941 0 18-8.059 18-18S28.941 1 19 1 1 9.059 1 19s8.059 18 18 18z", stroke: "#000", strokeWidth: "2" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-arrow-right-on.js
// module id = 1830
// module chunks = 0